// eslint-disable-next-line no-restricted-imports
import {
    Zone,
    SystemZone,
    type ZoneOffsetOptions,
    type ZoneOffsetFormat,
} from "luxon";

let singleton: DateZone | null = null;

/**
 * A wrapper around SystemZone. The only difference is the zone type (date). Use this to mark DateTimes that are meant to be Dates. superjson will detect this and serialize them as dates.
 */
export class DateZone extends Zone<true> {
    #systemZone: SystemZone;
    override get name() {
        return this.#systemZone.name;
    }
    /**
     * Use DateZone.instance instead.
     */
    private constructor() {
        super();
        this.#systemZone = SystemZone.instance;
    }
    static get instance() {
        if (!singleton) {
            singleton = new DateZone();
        }
        return singleton;
    }
    override equals(other: Zone): boolean {
        return other.type === "date";
    }
    override get isValid() {
        return this.#systemZone.isValid;
    }
    override get type() {
        return "date";
    }
    override get isUniversal() {
        return this.#systemZone.isUniversal;
    }
    override offsetName(ts: number, opts: ZoneOffsetOptions) {
        return this.#systemZone.offsetName(ts, opts);
    }
    override formatOffset(ts: number, format: ZoneOffsetFormat) {
        return this.#systemZone.formatOffset(ts, format);
    }
    override offset(ts: number) {
        return this.#systemZone.offset(ts);
    }
}
